export const common = {
  // Header
  'header.home': 'Home',
  'header.purchase': 'Purchase',
  'header.about': 'About',
  'header.messages': 'Messages',
  'header.contact': 'Contact',
  
  // Hero Section
  'hero.title': 'Buy USDT Instantly with DP Crypt',
  'hero.description': 'Fast, secure, and reliable USDT trading platform. Get the best rates with instant transactions and 24/7 support.',
  'hero.cta.buy': 'Buy USDT Now',
  'hero.trust.secure': 'Secure & Licensed',
  'hero.trust.instant': 'Instant Processing',
  'hero.trust.support': '24/7 Support',
  
  // Trading Widget
  'trading.title': 'Buy USDT',
  'trading.youSpend': 'You spend',
  'trading.youReceive': 'You receive',
  'trading.rate': 'Exchange Rate',
  'trading.fee': 'Processing Fee',
  'trading.button': 'Buy USDT Now',
  'trading.rateUpdate': 'Real-time rates updated every 30 seconds',
  
  // Features Section
  'features.title': 'Why Choose DP Crypt?',
  'features.subtitle': 'Experience the most secure, fast, and user-friendly cryptocurrency trading platform',
  'features.instant.title': 'Instant transactions',
  'features.instant.desc': 'We will transfer within 5 business days after confirming your deposit.',
  'features.seamless.title': 'Seamless Experience',
  'features.seamless.desc': 'An easy-to-use dashboard that takes you to payment approval effortlessly. Perfect for crypto beginners!',
  'features.peace.title': 'Peace of mind',
  'features.peace.desc': 'DP Crypt is fully licensed and regulated so you can venture into the world of cryptocurrencies safely.',
  'features.payment.title': 'Simple payment method',
  'features.payment.desc': 'We offer a variety of easy payment methods.',
  'features.fraud.title': 'Fraud protection',
  'features.fraud.desc': 'DP Crypt utilizes advanced tools that help us protect users and identify, prevent, and insure against losses from fraud.',
  'features.support.title': '24/7 support',
  'features.support.desc': 'We all need a helping hand from time to time. At DP Crypt, our exceptional customer care team is available to assist you around the clock.',
  
  // How It Works
  'howItWorks.title': 'How to Buy USDT Instantly',
  'howItWorks.step1.title': 'Do you have a receiving wallet?',
  'howItWorks.step1.desc': 'Do you have a wallet ready to receive USDT? Please prepare a TRC20 USDT wallet.',
  'howItWorks.step2.title': 'Check the crypto prices',
  'howItWorks.step2.desc': 'View real-time prices of USDT and other cryptos and select how much you want to purchase. Choose your preferred payment option and complete the payment details.',
  'howItWorks.step3.title': 'Receive your USDT',
  'howItWorks.step3.desc': 'Once your transaction is submitted, we\'ll send the crypto to your wallet within 30 minutes of payment approval. It\'s that easy!',
  'howItWorks.cta': 'Buy Crypto',
  
  // Trust Section
  'trust.title': 'Trusted Globally Since 2025',
  'trust.subtitle': 'Our service is trusted by 10k+ satisfied customers worldwide',
  'trust.testimonial1.name': 'Sarah Johnson',
  'trust.testimonial1.role': 'Crypto Investor',
  'trust.testimonial1.content': 'DP Crypt made buying my first Bitcoin incredibly easy. The process was smooth and I received my crypto within 15 minutes!',
  'trust.testimonial2.name': 'Michael Chen',
  'trust.testimonial2.role': 'Day Trader',
  'trust.testimonial2.content': 'The platform is reliable and secure. I\'ve been using DP Crypt for over six months and never had any issues with transactions.',
  'trust.testimonial3.name': 'Emma Rodriguez',
  'trust.testimonial3.role': 'Business Owner',
  'trust.testimonial3.content': 'Excellent customer support and competitive rates. DP Crypt is my go-to platform for all cryptocurrency purchases.',
  'trust.badge.licensed': 'Licensed & Regulated',
  'trust.badge.security': 'Bank-Level Security',
  'trust.badge.support': '24/7 Support',
  
  // Footer
  'footer.buyCrypto': 'Buy Crypto',
  'footer.products': 'Products',
  'footer.auroraCard': 'Aurora Card',
  'footer.support': 'Support',
  'footer.contact': 'Contact Us',
  'footer.about': 'About Us',
  'footer.privacy': 'Privacy Policy',
  'footer.rights': 'All rights reserved.',
  'footer.description': 'Buy USDT instantly with payment method. Fast, secure, and trusted by thousands worldwide.',
  
  // Aurora Card
  'aurora.hero.title': 'Aurora Card',
  'aurora.hero.subtitle': 'Revolutionary Credit Card for Cryptocurrency',
  'aurora.hero.description': 'Store multiple cryptocurrencies and make payments at over 80 million merchants in 210 countries worldwide. No need for complicated cash-out procedures.',
  'aurora.hero.cta.signup': 'Sign Up Now',
  'aurora.hero.cta.website': 'Visit Official Site',
  
  'aurora.overview.title': 'What is Aurora Card?',
  'aurora.overview.subtitle': 'Next-generation credit card that allows you to use cryptocurrency directly for payments without cashing out',
  'aurora.overview.feature1.title': 'Multiple Cryptocurrencies Supported',
  'aurora.overview.feature1.desc': 'Manage multiple cryptocurrencies including Bitcoin, Ethereum, and USDT with one card. Easy deposits through the official app.',
  'aurora.overview.feature2.title': 'Use Worldwide',
  'aurora.overview.feature2.desc': 'Available at over 80 million Mastercard merchants in 210 countries worldwide. Works perfectly in Japan too.',
  'aurora.overview.feature3.title': 'No Complicated Procedures',
  'aurora.overview.feature3.desc': 'No need for the traditional "wallet → exchange → bank account" cash-out process. Simply deposit to the app and pay instantly.',
  'aurora.overview.feature4.title': 'High Security',
  'aurora.overview.feature4.desc': 'Customer assets are legally protected through trust institutions. Complete blocking of third-party access to account information.',
  'aurora.overview.recommended.title': 'Recommended For',
  'aurora.overview.recommended.item1': 'Those who find cashing out cryptocurrency troublesome',
  'aurora.overview.recommended.item2': 'Those who want to use cryptocurrency easily',
  'aurora.overview.recommended.item3': 'Those who want a card with high safety and reliability',
  
  'aurora.comparison.title': 'Difference from Traditional Credit Cards',
  'aurora.comparison.subtitle': 'With Aurora Card, no need to cash out cryptocurrency',
  'aurora.comparison.traditional.title': 'Traditional Method',
  'aurora.comparison.traditional.step1': 'Send from wallet to exchange',
  'aurora.comparison.traditional.step1.fee': 'Transfer fee incurred',
  'aurora.comparison.traditional.step2': 'Cash out cryptocurrency on exchange',
  'aurora.comparison.traditional.step2.fee': 'Trading fee incurred',
  'aurora.comparison.traditional.step3': 'Withdraw to bank account',
  'aurora.comparison.traditional.step3.fee': 'Withdrawal fee incurred',
  'aurora.comparison.traditional.summary': 'Time-consuming and high fees',
  'aurora.comparison.aurora.title': 'Aurora Card Method',
  'aurora.comparison.aurora.step1': 'Deposit cryptocurrency to app',
  'aurora.comparison.aurora.step1.fee': 'Deposit fee: 1.3% only',
  'aurora.comparison.aurora.step2': 'Ready to pay immediately',
  'aurora.comparison.aurora.step2.fee': 'Use as credit card instantly',
  'aurora.comparison.aurora.summary': 'Simple with minimal fees',
  'aurora.comparison.table.title': 'Difference from Debit Cards',
  'aurora.comparison.table.cardType': 'Card Type',
  'aurora.comparison.table.creditCard': 'Credit Card',
  'aurora.comparison.table.debitCard': 'Debit Card',
  'aurora.comparison.table.postpaid': 'Postpaid Support',
  'aurora.comparison.table.trust': 'Trust Protection',
  'aurora.comparison.table.partial': 'Partial only',
  'aurora.comparison.table.merchants': 'Available Merchants',
  'aurora.comparison.table.allCredit': 'All credit-accepting stores',
  'aurora.comparison.table.debitOnly': 'Debit-accepting stores only',
  
  'aurora.trust.title': 'High Security Through Trust Institution Partnership',
  'aurora.trust.subtitle': 'Customer assets are legally protected with complete blocking of third-party access',
  'aurora.trust.features.title': 'Trust Account Features',
  'aurora.trust.features.confidentiality': 'High Confidentiality',
  'aurora.trust.features.confidentiality.desc': 'External parties cannot access customer trust asset information',
  'aurora.trust.features.risk': 'Risk Mitigation',
  'aurora.trust.features.risk.desc': 'Significantly reduces risks related to account freezing',
  'aurora.trust.features.privacy': 'Privacy Protection',
  'aurora.trust.features.privacy.desc': 'Complete blocking of third-party information viewing',
  'aurora.trust.bank.title': 'Comparison with Regular Bank Accounts',
  'aurora.trust.bank.lowConfidentiality': 'Low Confidentiality',
  'aurora.trust.bank.lowConfidentiality.desc': 'Judicial authorities can inspect information at any time',
  'aurora.trust.bank.freezeRisk': 'Freeze Risk',
  'aurora.trust.bank.freezeRisk.desc': 'Has the right to freeze accounts for specific reasons',
  'aurora.trust.bank.limitedPrivacy': 'Limited Privacy',
  'aurora.trust.bank.limitedPrivacy.desc': 'Third parties can access account information at any time',
  'aurora.trust.licenses.title': 'Held Licenses',
  
  'aurora.features.title': 'Main Features of Aurora Card',
  'aurora.features.subtitle': 'New standard for cryptocurrency payments',
  'aurora.features.mastercard.title': 'Mastercard Brand',
  'aurora.features.mastercard.desc': 'Available at Mastercard merchants worldwide. Use both online and offline at a wide range of stores.',
  'aurora.features.unlimited.title': 'Unlimited Deposit & Payment Limits',
  'aurora.features.unlimited.desc': 'No deposit limits. Unlimited payments within your app credit balance.',
  'aurora.features.japan.title': 'Available in Japan',
  'aurora.features.japan.desc': 'Works perfectly at Mastercard merchants in Japan. Convenience stores, restaurants, online shops, and more.',
  'aurora.features.atm.title': 'ATM Withdrawal Support',
  'aurora.features.atm.desc': 'Withdraw up to $5,000 per day from ATMs. Available up to 5 times per day.',
  'aurora.features.postpaid.title': 'Postpaid Support',
  'aurora.features.postpaid.desc': 'Functions as a credit card, supporting postpaid payments. Convenience not available with debit cards.',
  'aurora.features.app.title': 'Easy Management with Dedicated App',
  'aurora.features.app.desc': 'Easily perform all operations from the official app: deposits, balance checks, transaction history, and more.',
  'aurora.features.notice.title': 'Important Notes',
  'aurora.features.notice.item1': 'Funds sent to the wallet cannot be transferred to other wallets.',
  'aurora.features.notice.item2': 'Card issuance requires $300 worth of USDT.',
  'aurora.features.notice.item3': 'For tax filing, please consult your local tax office or tax accountant.',
  
  'aurora.fees.title': 'Fee Schedule',
  'aurora.fees.subtitle': 'Transparent pricing structure',
  'aurora.fees.item': 'Item',
  'aurora.fees.fee': 'Fee',
  'aurora.fees.issuance': 'Card Issuance Fee',
  'aurora.fees.deposit': 'Deposit Fee',
  'aurora.fees.annual': 'Annual Membership Fee',
  'aurora.fees.annual.note': '(Subject to change)',
  'aurora.fees.atmWithdrawal': 'ATM Withdrawal Fee',
  'aurora.fees.atmWithdrawal.note': '(5% transaction fee + 3% ATM withdrawal fee)',
  'aurora.fees.atmLimit': 'ATM Withdrawal Limit',
  'aurora.fees.atmLimit.value': '5,000USDT/day',
  'aurora.fees.atmLimit.note': '(Daily ATM usage: up to 5 times)',
  'aurora.fees.depositLimit': 'Deposit Limit',
  'aurora.fees.paymentLimit': 'Payment Limit',
  'aurora.fees.paymentLimit.note': '(App credit balance)',
  'aurora.fees.transaction': 'Transaction Fee',
  'aurora.fees.brand': 'Brand',
  'aurora.fees.japanUse': 'Use in Japan',
  'aurora.fees.available': 'Available',
  'aurora.fees.unlimited': 'Unlimited',
  'aurora.fees.info': 'Card issuance requires $300 worth of USDT. This fee is one-time only.',
  
  'aurora.cta.title': 'Use Cryptocurrency More Freely',
  'aurora.cta.description': 'Aurora Card is especially recommended for cryptocurrency holders. Skip the complicated cash-out process and gain the freedom to pay with cryptocurrency anywhere in the world.',
  'aurora.cta.button.apply': 'Apply for Card Now',
  'aurora.cta.button.details': 'View Details',
  'aurora.cta.support.title': 'Customer Support',
  'aurora.cta.support.telegram': 'Telegram',
  'aurora.cta.support.email': 'Email',
  'aurora.cta.disclaimer.title': 'Notes & Disclaimer',
  'aurora.cta.disclaimer.text': 'This page is for informational purposes only. Please use at your own discretion. While we take great care in posting information, we do not guarantee accuracy or completeness and cannot be held responsible for any losses incurred. Please understand. *Information may change without notice.',

  // Lending
  'lending.hero.title': 'Crypto Lending',
  'lending.hero.subtitle': 'Grow Your Assets Simply by Depositing',
  'lending.hero.currencies': 'Supported Currencies',
  'lending.hero.apy': 'Annual Yield',
  'lending.hero.cta.start': 'Get Started Now',
  'lending.hero.cta.learn': 'Learn More',

  'lending.recommended.title': 'Crypto Lending is Recommended For',
  'lending.recommended.item1.title': 'Those who want to utilize idle crypto assets',
  'lending.recommended.item2.title': 'Those unsatisfied with stocks or mutual funds',
  'lending.recommended.item3.title': 'Those who want to start crypto asset management',
  'lending.recommended.item4.title': 'Those interested in crypto but unsure how to start',

  'lending.safety.title': 'Safe Start Even for Beginners',
  'lending.safety.zero1.title': 'Zero Fees for Peace of Mind',
  'lending.safety.zero1.desc': 'No transfer or return fees - zero extra costs!',
  'lending.safety.zero1.badge': 'Completely Free!!',
  'lending.safety.zero2.title': 'Zero Knowledge Required with Auto Management',
  'lending.safety.zero2.desc': 'Just "select, deposit, and wait" - automatic management does the rest!',
  'lending.safety.zero2.badge': 'No Expertise Needed!!',
  'lending.safety.zero3.title': 'Growing Satisfaction, No Decrease',
  'lending.safety.zero3.desc': 'Your deposited crypto stays intact - just wait for it to grow!',
  'lending.safety.zero3.badge': 'Same Amount + α',
  'lending.safety.zeroRisk.title': 'Zero Risk Design',
  'lending.safety.zeroRisk.desc': 'Zero risk design addressing all conceivable risks',

  'lending.about.title': 'What is DP Crypt Lending',
  'lending.about.desc1': 'DP Crypt has assembled a team of professional traders who comprehensively analyze not only the crypto market but also global economy, stocks, bonds, forex, and all markets to establish our unique management method.',
  'lending.about.desc2': 'This enables us to offer lending for 21 types of cryptocurrencies - the most in the industry.',
  'lending.about.desc3': 'We provide a safe and secure environment for all investors, from lending beginners to those already using other services.',

  'lending.rates.badge': 'No.1',
  'lending.rates.title': 'Industry-Leading Yields',
  'lending.rates.subtitle': 'Top-class in both number of supported currencies and annual yield',
  'lending.rates.currencies': 'Cryptocurrencies',
  'lending.rates.annual': 'Annual',
  'lending.rates.desc': 'Experienced professional traders manage 24/7. Furthermore, we implement a unique model designed through thorough data analysis rather than leaving it to market conditions. This is why we can achieve stable returns even with high yields.',

  'lending.plans.title': 'Choose from 2 Lending Plans',
  'lending.plans.subtitle': 'Safe lending plans available',
  'lending.plans.annual': 'Annual',
  'lending.plans.recommended': 'Recommended',
  'lending.plans.standard.period': '1-Month Term',
  'lending.plans.standard.name': 'Standard',
  'lending.plans.standard.desc': 'After 1 month from deposit, you can return your crypto assets at your timing',
  'lending.plans.standard.feature1': 'Return anytime after 1 month',
  'lending.plans.standard.feature2': 'Flexible management possible',
  'lending.plans.extra.period': '1-Year Term',
  'lending.plans.extra.name': 'Extra',
  'lending.plans.extra.desc': 'Cannot return for 1 year but high return at 13.2% annually! Auto-renews after 1 year for another 1-year contract',
  'lending.plans.extra.feature1': 'Industry-leading 13.2% annual yield',
  'lending.plans.extra.feature2': 'Auto-renewal after 1 year, ideal for long-term management',

  'lending.howItWorks.title': 'What is Crypto Lending',
  'lending.howItWorks.step1.title': '1. Deposit',
  'lending.howItWorks.step1.desc': 'Deposit USDT to start lending',
  'lending.howItWorks.step2.title': '2. Management',
  'lending.howItWorks.step2.desc': 'Professionals safely manage your assets',
  'lending.howItWorks.step3.title': '3. Receive',
  'lending.howItWorks.step3.desc': 'Receive daily interest and grow your assets',
  'lending.howItWorks.badge': '24/7 Automated Management',
  'lending.howItWorks.desc': 'By depositing your cryptocurrency with us for a certain period, we return it with the same number of coins plus additional returns. Our professional management team uses proprietary know-how to diversify investments across various markets. The capital gains obtained through this process are returned to our customers.',
  'lending.howItWorks.advantage.title': 'Double Opportunity',
  'lending.howItWorks.advantage.desc': 'Increase your holdings! Plus, if the asset value rises, you get a double opportunity! Cryptocurrency allows you to increase the number of coins you hold, and as prices rise, your asset value also increases. While the market is highly volatile and regular trading carries risks, lending allows you to steadily increase your holdings without being affected by price fluctuations.',

  'lending.comparison.badge': 'Comparison',
  'lending.comparison.title': 'Industry-Leading Service',
  'lending.comparison.table.feature': 'Feature',
  'lending.comparison.table.mycoin': 'DP Lending',
  'lending.comparison.table.others': 'Other Services',
  'lending.comparison.table.rate': 'Annual Rate',
  'lending.comparison.table.fee': 'Fees',
  'lending.comparison.table.free': 'Free',
  'lending.comparison.table.charged': 'Charged',
  'lending.comparison.table.minAmount': 'Minimum Amount',
  'lending.comparison.table.noMin': 'No Limit',
  'lending.comparison.table.hasMin': 'Has Limit',
  'lending.comparison.table.lockPeriod': 'Lock Period',
  'lending.comparison.table.noLock': 'None',
  'lending.comparison.table.hasLock': 'Required',
  'lending.comparison.table.currencies': 'Supported Currencies',
  'lending.comparison.table.types': 'Types',
  'lending.comparison.table.support': 'Support',
  'lending.comparison.table.limited': 'Limited',
  'lending.comparison.table.withdrawal': 'Withdrawal',
  'lending.comparison.table.anytime': 'Anytime',
  'lending.comparison.table.restricted': 'Restricted',
  'lending.comparison.terms.title': 'Glossary',
  'lending.comparison.terms.period.title': 'Deposit Period',
  'lending.comparison.terms.period.desc': 'The period for depositing crypto assets with the lending service. During this time, withdrawal or sale is not possible. Generally, longer deposit periods tend to have higher annual yields.',
  'lending.comparison.terms.reinvest.title': 'Auto Reinvestment',
  'lending.comparison.terms.reinvest.desc': 'A mechanism that automatically reinvests earned interest. Management profits generate interest, which is further reinvested, creating a compound effect that efficiently grows assets.',
  'lending.comparison.terms.fees.title': 'Fees',
  'lending.comparison.terms.fees.return': '①Return Fee',
  'lending.comparison.terms.fees.returnDesc': 'Fee charged when returning crypto assets after the management period ends.',
  'lending.comparison.terms.fees.transfer': '②Transfer Fee',
  'lending.comparison.terms.fees.transferDesc': 'Blockchain usage fee when sending crypto assets.',
  'lending.comparison.terms.fees.noFee': '*With us, there are absolutely no fees!',

  'lending.security.title': 'Visible Peace of Mind! Protected Trust!',
  'lending.security.subtitle': 'Dedicated management site for each customer',
  'lending.security.desc': 'What matters most when starting asset management is "how safely you can deposit." We provide a dedicated management site for each customer. You can check deposit status, yields, grant history, and other information in real-time.',
  'lending.security.bankLevel': 'Bank-Level Security',
  'lending.security.feature1': 'Encrypted Communication (SSL/TLS)',
  'lending.security.feature2': 'Two-Factor Authentication (2FA)',
  'lending.security.feature3': 'Auto Logout When Inactive',
  'lending.security.feature4': 'Server Monitoring & Fraud Detection',

  'lending.steps.title': 'Easy Registration in 3 Steps',
  'lending.steps.subtitle': 'STEP Easy Registration',
  'lending.steps.step1.title': 'Member Registration',
  'lending.steps.step1.desc': 'Register your name, email address, and password. An authentication code will be sent to your email address, please complete authentication.',
  'lending.steps.step2.title': 'Upload ID',
  'lending.steps.step2.desc': 'Take a photo and upload one of the following: My Number Card / Health Insurance Card / Driver\'s License.',
  'lending.steps.step3.title': 'Start Lending',
  'lending.steps.step3.desc': 'Set your plan, currency, and deposit amount, send your crypto assets, and start lending!',

  'lending.faq.title': 'Frequently Asked Questions',
  'lending.faq.q1.question': 'How is interest calculated?',
  'lending.faq.q1.answer': 'Interest = (Deposit Amount × Deposit Period (days) × Annual Rate) ÷ 365\n\nExample: Standard Course (10% annual rate)\n(20 coins × 200 days × 10%) ÷ 365 = 1.0958\n\nInterest is calculated and granted daily, so your assets steadily increase every day.',
  'lending.faq.q2.question': 'What is the minimum lending period?',
  'lending.faq.q2.answer': 'The minimum lending period is 1 month (30 days). When lending crypto assets, returns are not possible for 30 days from the lending execution date (the day after we complete receipt processing).',
  'lending.faq.q3.question': 'Why can you achieve higher interest than other companies?',
  'lending.faq.q3.answer': 'The crypto assets you deposit are managed by our specialized management team across multiple markets, accurately capturing market trends. In the management process, we actively pursue profit opportunities such as capital gains using unique analysis and strategies. By returning these results to customers, we achieve higher interest than competitors.',
  'lending.faq.q4.question': 'Can I deposit in Japanese Yen since I don\'t know about crypto?',
  'lending.faq.q4.answer': 'We apologize, but we only handle crypto assets. We do not support direct deposits in Japanese Yen. Please use by depositing crypto assets you own.',
  'lending.faq.q5.question': 'Are there return fees?',
  'lending.faq.q5.answer': 'We do not charge any fees including return fees, transfer fees, or cancellation fees, so please rest assured.',

  'lending.cta.title': 'Get Everything You Want Just by Depositing!',
  'lending.cta.description': 'Simply deposit your crypto assets to achieve stable yields. No expertise required - anyone can easily get started.',
  'lending.cta.button': 'Get Started Now',
  'lending.cta.disclaimer.title': 'Notes & Disclaimer',
  'lending.cta.disclaimer.text': 'This page is for informational purposes only. Please use at your own discretion. While we take great care in posting information, we do not guarantee accuracy or completeness and cannot be held responsible for any losses incurred. Please understand. *Information may change without notice.',
};

export default common;
